import { IAction } from './action';

export class SetHasFooter implements IAction {
    constructor(public hasFooter: boolean) { }
}
